module.exports = __webpack_public_path__ + "assets/img/MM.6756d55f.png";